export const EXAMPLE_FUNCTION = 'temp/EXAMPLE_FUNCTION';
